import React,{Component,Fragment} from 'react';
import {nutritions, updatedNutritions} from '../../../../server/constants.js';
import {allowNumericWithdecimal, convertTwoDecimalPoint } from '../../../../server/util.js'

class NutritionCtrl extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            loading: false
        }
    }
    render(){
        return(<Fragment>
        <div className="row" style={{marginTop:'10px'}}>
            <div className="col-md-12">
                <h4 className="sub-title text-danger" style={{marginBottom:'10px'}} >{'Nutrition Info'}</h4>
            </div>
        </div>
        <div className="row">
            <div className="col-sm-12 " style={{fontSize:'10px'}}>
            
                

                
            
            <ul class="list-group row">
                {          
                Object.keys(updatedNutritions).map((item,k)=>{
                    return (<li class="list-group-item col-sm-4 col-md-4 col-xs-12" style={{ padding:"5px 15px", border:'0'}}>
                    <label htmlFor={'id'+item} className="control-label">{updatedNutritions[item].display}</label>
                    <input type="text" className="form-control" autoComplete='off' id={'id'+item} style={{padding:'5px'}}
                     tabindex={updatedNutritions[item].tabindex} name={item} value={this.props.data[updatedNutritions[item].code]||''} 
                     placeholder="0" onChange={(e)=>{
                        this.props.onValueChange(e.target.name,e.target.value);
                    }} onKeyPress={(e)=>{allowNumericWithdecimal(e)}} onKeyUp={(e)=>{
                        allowNumericWithdecimal(e);
                        }} onBlur={(e)=>{
                            allowNumericWithdecimal(e);
                            //this.props.onValueChange(e.target.name,convertTwoDecimalPoint(e.target.value));
                            }}/>
                  </li>)

                           {/*  <label  className="col-sm-9 control-label">{updatedNutritions[item].display}</label>
                            <div className="col-sm-3">
                                <input id={'id'+item} style={{padding:'5px'}}  tabindex={updatedNutritions[item].tabindex} name={item} value={this.props.data[item]||''} type="text" className="form-control"
                                 placeholder="0" onChange={(e)=>{
                                     this.props.onValueChange(e.target.name,e.target.value);
                                 }} onKeyPress={(e)=>{allowNumericWithdecimal(e)}} onKeyUp={(e)=>{
                                     allowNumericWithdecimal(e);
                                     }} onBlur={(e)=>{
                                         allowNumericWithdecimal(e);
                                         //this.props.onValueChange(e.target.name,convertTwoDecimalPoint(e.target.value));
                                         }} />
                            </div> 
                        
                    </div>*/}
                })
            }   
            </ul>             
           </div></div>

        </Fragment>);
    }
}
export default NutritionCtrl


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Caterer/MenuMaster/nutritionCtrl.jsx